export default __webpack_public_path__ + "static/media/block.002983e9.svg";